import React from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import './assets/css/font-awesome.css';
import './assets/css/image-optimization.css';
import './index.css';
import './assets/css/responsive.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import { render } from 'react-snapshot';

render(<App />, document.getElementById('root'));
registerServiceWorker();
